import { render, staticRenderFns } from "./CustomerPaymentBehaviourList.vue?vue&type=template&id=188a94fb&scoped=true&"
import script from "./CustomerPaymentBehaviourList.vue?vue&type=script&lang=ts&"
export * from "./CustomerPaymentBehaviourList.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerPaymentBehaviourList.vue?vue&type=style&index=0&id=188a94fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188a94fb",
  null
  
)

export default component.exports